<div class="header">
  <div class="content">
    <div class="contentInner">
      <div class="pageTitle" appReveal>
        <div class="headline">Dash Enterprise</div>
      </div>
    </div>
    <app-enterprise-tab-navigator></app-enterprise-tab-navigator>
  </div>
</div>
<div class="content">
  <div class="contentInner">
    <h1 class="title">Dash Enterprise Web App</h1>
    <p class="intro">The dash web app is useful for devices that aren't supported by our mobile apps.  It has the same features as our mobile apps, and can be configured in much the same way.</p>

    <h2 class="sectionHeader">Browser support</h2>
    <p>Dash supports a wide range of devices (including televisions, laptops, and tablets) and browsers, including devices running these browsers or browsers based on them:</p>
    <ul>
      <li>Chrome 60 and above</li>
      <li>Edge 79 and above</li>
      <li>Firefox 63 and above</li>
      <li>Safari 11.1 and above</li>
    </ul>
    <p>To check if Dash supports your device, you can use this demo link: <a href="https://app.get-dash.com/?demo" target="_blank">https://app.get-dash.com/?demo</a></p>

    <h2 class="sectionHeader">Setting up a web device</h2>
    <app-illustration alt="Adding a new web device in Dash Enterprise" src="/assets/images/dash-enterprise-create-web-device.png" webpSrc="/assets/images/dash-enterprise-create-web-device.webp" width="600" height="370" class="illustration"></app-illustration>
    <p>The Dash web app is configured in the web management dashboard, and web devices are created and configured in
      <a routerLink="/enterprise/dashboard-configuration">device groups</a>.</p>

    <p>Start by <a href="https://enterprise.get-dash.com/device-groups" target="_blank">creating a new device group</a>
      or opening an existing one, then click <i>New device</i> and choose <i>Web app</i> as the type.  Enter a name for
      your device, and click <i>Create</i>.</p>

    <div style="clear:both"></div>
    <h2 class="sectionHeader">Pairing code</h2>
    <app-illustration alt="The URL and pairing code of your new web device in Dash Enterprise" src="/assets/images/dash-enterprise-web-pairing-code.png" webpSrc="/assets/images/dash-enterprise-web-pairing-code.webp" width="600" height="644" class="illustration"></app-illustration>
    <p>After you click <i>Create</i>, you’ll receive a unique web link and pairing code for your new device. If your
      device supports QR codes, scan the provided code to open the link. Otherwise, copy the link and open it on your
      device.</p>

    <p>Once the Dash app has loaded, enter the pairing code to register the device. After pairing, the room display will
      load with the configured settings from your dashboard.</p>

    <p>Configuring the Dash web app works the same way as the mobile app. For more details, see our guide on
      <a routerLink="/enterprise/dashboard-configuration">configuring Dash</a>.</p>

    <p class="tip icon"><span>You can view the QR code and pairing code again by clicking the <i>View</i> button
      in the <i>Link</i> column of the devices table.</span></p>

    <div style="clear:both"></div>
    <h2 class="sectionHeader">Troubleshooting your configuration</h2>
    <p>To check the configuration settings applied to your device, go to the <i>Device Group</i> or
      <i>All Devices section</i> of the dashboard, select your device, and click <i>Edit Configuration</i>. Enable
      <i>Show configuration debugging information on the device</i> and click <i>Save</i>. Now you will see a popup at
      the bottom of the screen each time the device updates its configuration. Tap the popup to view all applied
      settings and their values.  Any settings with errors will be flagged by an icon.</p>

    <p>When you’re happy with the device’s configuration, turn off the debugging option to hide the popup.</p>
  </div>
</div>
